import axiosInstance from "../../../api/axiosConfig";

export const getBannerImages = (params: any) => {
  return axiosInstance.get("/admin/banner-images", {
    params: params,
  });
};

export const deleteBannerImage = (id: string) => {
  return axiosInstance.delete(`/admin/banner-images/${id}`);
};
